/**
 * Shared reservation-payment predicates, split out of `ReservationActionDialogs.tsx`
 * so that file's Fast Refresh keeps working (a component file only exporting
 * components — the DNKADM-0278 precedent, `calendar/nowNextBuckets.ts` split out of
 * `NowNextView.tsx` for the same reason).
 *
 * `isCreditFunded` is reused by BOTH the check-in/no-show confirm-charge dialogs
 * (arm/suppress a card charge) and the DNKADM-0350 payment-state derivation
 * (`calendar/derive.ts`, U2/U3) — ONE definition of "credit-funded," never forked.
 */

/**
 * Null and numeric zero keep the ordinary charge path. Every other runtime value,
 * including malformed/unknown data, fails safe as credit-funded so it cannot arm a
 * card charge.
 */
export function isCreditFunded(creditsCharged: unknown, creditsChargedKnown?: boolean): boolean {
  return creditsChargedKnown === false || (creditsCharged !== null && creditsCharged !== 0);
}
